<template>
  <div class="map-box" style="height: 100%;width: 100%;">
    <div class="search-box" style="display: flex;">
      <a-input id="input" v-model="searchName" placeholder="请输入地址查询" />
      <a-button @click="mapSearch(searchName)" type="primary" icon="el-icon-search" class="search-btn">搜索</a-button>
      <!-- <div id="out"></div> -->
      <div v-if="searchData.length > 0" class="el-amap-search-box">
        <div v-for="(item, index) in searchData" :key="index" class="el-amap-search-item" @click="mapSearchClick(item)">
          <span>{{ item.name }}</span>
        </div>

      </div>
    </div>
    <el-amap
      class="amap-box"
      :events="events"
      :zoom="zoom"
      :center="center"
      :plugin="plugin"
      vid="map"
      ref="map_ser"
    >
      <el-amap-marker
        v-for="(marker,index) in markers"
        :position="[marker.lng, marker.lat]"
      ></el-amap-marker>
    </el-amap>
  </div>
</template>

<script>
export default {
  name: 'DeviceMapG',
  props: {
    width: {
      type: String || Number,
      default: '100%'
    },
    height: {
      type: String || Number,
      default: '100%'
    }
  },
  data () {
    return {
      showPoint: true,
      showMarker: false,
      map: null,
      zoom: 15,
      center: [113.27, 23.13],
      markers: [],
      points: [],
      infoWindow: null,
      clickTimer: null, // 定时器
      clickCount: 0, // 点击次数
      searchName: '',
      searchObj: null,
      searchData: [],
      plugin: [],
      errorInfo: {
        'INVALID_USER_KEY': 'key不正确或过期',
        'SERVICE_NOT_AVAILABLE': '服务不可用',
        'INVALID_USER_SCODE': '安全码未通过验证',
        'INVALID_USER_DOMAIN': '绑定域名无效',
        'USERKEY_PLAT_NOMATCH': '请求key与绑定平台不符',
        'NOT_SUPPORT_HTTPS': '服务不支持https请求',
        'INSUFFICIENT_PRIVILEGES': '权限不足，服务请求被拒绝',
        'USER_KEY_RECYCLED': 'Key被删除',
        'INVALID_PARAMS': '请求参数非法',
        'MISSING_REQUIRED_PARAMS': '缺少必填参数',
        'UNKNOWN_ERROR': '其他未知错误',
        'OUT_OF_SERVICE': '规划点（包括起点、终点、途经点）不在中国陆地范围内',
        'NO_ROADS_NEARBY': '规划点（起点、终点、途经点）附近搜不到路',
        'ROUTE_FAIL': '路线计算失败，通常是由于道路连通关系导致',
        'OVER_DIRECTION_RANGE': '起点终点距离过长',
        'ENGINE_RESPONSE_DATA_ERROR': '服务响应失败'
      },
      events: {
        init (map) {
          console.log(map, 'mapmapmapmap==================')
          this.map = map
          map.setMapStyle('amap://styles/352c0d35426816fd4fbd6547dba6d4e9')
        },
        click: (e) => {
          // const that = this
          if (!e) {
            return
          }
          const positionArr = []
          positionArr.push(e.lnglat.lng)
          positionArr.push(e.lnglat.lat)
          console.log('e>>>>>', e)

          this.markers = []
          // this.markers.push({ lng: positionArr[0], lat: positionArr[1] });
          this.geoCoder(positionArr)
        }

      },
      renderMarker: (context) => {
        // console.log('==context==', context)
        context.marker.setContent(context.data[0].content)
        context.marker.setIcon(context.data[0].icon)
      }
    }
  },
  mounted () {
    const pluginObj = {
      city: '全国', // 城市
      type: '', // 数据类别
      pageSize: 100000, // 每页结果数,默认10
      pageIndex: 1, // 请求页码，默认1
      extensions: 'base', // 返回信息详略，默认为base（基本信息）
      pName: 'PlaceSearch',
      output: 'out',
      input: 'input',
      events: {}
    }
    pluginObj.events = {
      init: (o) => {
        console.log('插件初始化>>>>', o)
        console.log('插件初始化>>>>this>>>>', this)
        this.searchObj = o
        // o.on('select', (e) => {
        //   console.log('搜索地图>>>>', e)
        //   console.log('搜索地图>>>>this>>>>', this)

        //   this.markers = []
        //   console.log(e)
        //   if (e.poi.location) {
        //     this.center = [e.poi.location.lng, e.poi.location.lat]
        //     this.markers = [{ lng: e.poi.location.lng, lat: e.poi.location.lat, name: e.poi.name }]
        //     this.geoCoder([e.poi.location.lng, e.poi.location.lat])
        //   }
        // })
      }
    }
    this.plugin = []
    this.plugin.push(pluginObj)
  },
  methods: {
    init (data) {
      if (data.deviceLongitude && data.deviceLatitude) {
        this.center = [data.deviceLongitude, data.deviceLatitude]
        this.markers.push({
          lng: data.deviceLongitude,
          lat: data.deviceLatitude
        })
      } else {
        this.markers = []
        this.center = [113.27, 23.13]
      }
    },
    clickPoint (e) {
      console.log('点击居合点', e)
      if (e.clusterData.length === 1) {
        this.$emit('clickMarker', e.clusterData[0])
      }
    },
    clickMarker (marker) {
      console.log('点击mark点', marker)
    },
    /**
     * @desc 设置mark点到地图中心并显示信息窗
     * @param {  }
     * @version: 1.0.0
     */
    toMapCenter (item) {
      // console.log(item, 'toMapCentertoMapCentertoMapCenter')
      if (this.map && item.deviceLongitude && item.deviceLatitude) {
        this.map.setZoomAndCenter(17, [item.deviceLongitude, item.deviceLatitude])
        // 3. 找到目标marker并更换图标
        const targetMarker = this.markers.find(marker => {
          // 匹配唯一标识（优先用deviceCode）
          return marker.deviceCode === item.deviceCode
        })
        if (targetMarker) {
          this.openInfo(targetMarker)
        }
      }
    },
    mClick (item) {
      this.openAmapNavigation(item)
      item.visible = true
    },
    mMouseover (item) {
      console.log(item)
      this.openInfo(item)
    },
    mDblclick (item) {
      console.log('双击事件', item)
      if (item.deviceCategorizeCode != null) {
        if (item.deviceCategorizeCode === 'yin_protection_pile') {
          this.$router.push({ name: 'Device', params: { deviceCode: item.deviceCode } })
        } else if (item.deviceCategorizeCode === 'electric_drainage') {
          this.$router.push({ name: 'Electric_drainage', params: { deviceCode: item.deviceCode } })
        } else if (item.deviceCategorizeCode === 'recorder') {
          this.$router.push({ name: 'Recorder', params: { deviceCode: item.deviceCode } })
        }
      }
    },
    openInfo(item) {
      if (this.infoWindow) {
        this.infoWindow.close()
        this.infoWindow = null
      }
      // 构建信息窗体中显示的内容
      this.infoWindow = new AMap.InfoWindow({
        content: item.info.join(''), // 使用默认信息窗体框样式，显示信息内容
        offset: new AMap.Pixel(0, -20)
      })
      // console.log('>>>>>>>>>>>', this.map)
      setTimeout(() => { // 延迟确保DOM已渲染
        // console.log('>>>>>>>>>>>>', document.getElementById('content_title_btn_' + item.deviceCode))

        const btn = document.getElementById('content_title_btn_' + item.deviceCode)
        if (btn) {
          btn.addEventListener('click', () => {
            console.log('打开高德导航')
            // 业务逻辑...
            this.openAmapNavigation(item)
          })
        }

        const infoWindowClose = document.getElementById('content_window_btn_' + item.deviceCode)
        if (infoWindowClose) {
          infoWindowClose.addEventListener('mouseleave', (e) => {
            // console.log('关闭信息弹窗')
            // if (e.relatedTarget !== this && !this.contains(e.relatedTarget)) {
            //   console.log('鼠标已经移出父元素');
            //   // 在这里执行你的代码
            //   if (this.infoWindow) {
            //     this.infoWindow.close()
            //     this.infoWindow = null
            //   }
            // }
            // e.stopPropagation()
            // // 业务逻辑...
            if (this.infoWindow) {
              this.infoWindow.close()
              this.infoWindow = null
            }
          })
        }
      }, 100)
      this.infoWindow.open(this.map, [item.deviceLongitude, item.deviceLatitude])
    },
    /** 打开高德导航 */
    openAmapNavigation(record) {
      var fromLongitude = ''
      var fromLatitude = ''
      var fromPlaceName = ''
      this.getCurrentLocation().then(res => {
        fromLongitude = res.longitude
        fromLatitude = res.latitude
        var toLongitude = record.deviceLongitude
        var toLatitude = record.deviceLatitude
        var toPlaceName = record.locationDescription
        console.log('起点：' + fromLongitude + ',' + fromLatitude)
        console.log('终点：' + toLongitude + ',' + toLatitude)
        const url = `https://uri.amap.com/navigation?from=${fromLongitude},${fromLatitude},${encodeURIComponent(fromPlaceName)}&to=${toLongitude},${toLatitude},${encodeURIComponent(toPlaceName)}&mode=car&policy=0&callnative=1`
        window.open(url, '_blank')
      }).catch(err => {
        this.$message.warning(err)
      })
    },
    getCurrentLocation() {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(new Error('浏览器不支持定位功能'))
          return
        }
        navigator.geolocation.getCurrentPosition(
          // 成功回调
          (position) => {
            const location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              accuracy: position.coords.accuracy,
              altitude: position.coords.altitude,
              altitudeAccuracy: position.coords.altitudeAccuracy,
              heading: position.coords.heading,
              speed: position.coords.speed,
              timestamp: position.timestamp
            }
            resolve(location)
          },
          // 失败回调
          (error) => {
            let errorMessage = ''
            switch (error.code) {
              case error.PERMISSION_DENIED:
                errorMessage = '用户拒绝定位请求'
                break
              case error.POSITION_UNAVAILABLE:
                errorMessage = '位置信息不可用'
                break
              case error.TIMEOUT:
                errorMessage = '定位请求超时'
                break
              case error.UNKNOWN_ERROR:
                errorMessage = '未知错误'
                break
            }
            reject(errorMessage)
          },
          // 可选配置
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
          }
        )
      })
    },
    clickArrayMarker (item, e) {
      console.log('点击mark点', item)
      this.$emit('clickMarker', item)
    },

    mapSearch(keyword) {
      // let searchObj = null
      this.searchObj.search(keyword, (error, result) => {
        console.log('搜索结果>>>>', error, result)
        if (error && result.info !== 'OK') {
          // this.$message.error(error)
          return
        }
        this.searchData = []
        if (result && result.poiList && result.poiList.pois.length > 0) {
          result.poiList.pois.forEach(item => {
            if (item.location) {
              this.searchData.push(item)
            }
          })
          // const lng = result.poiList.pois[0].location.lng
          // const lat = result.poiList.pois[0].location.lat
          // this.center = [lng, lat]
          // this.markers = [{ lng: lng, lat: lat, name: result.poiList.pois[0].name }]
          // this.geoCoder([lng, lat])
        }

        console.log('搜索结果>>>>', this.searchData)
      })
      // this.searchObj.search(keyword,searchObj)
      // this.mapObj.event.addListener(this.searchObj, "complete", searchObj); //返回结果
    },
    mapSearchClick(item) {
      this.markers = []
      const lng = item.location.lng
      const lat = item.location.lat
      this.center = [lng, lat]
      // this.markers = [{ lng: lng, lat: lat, name: item.district+item.name }]
      this.geoCoder([lng, lat])
      this.searchData = []
    },
    geoCoder(positionArr) {
      // 获取地址经纬度和省市区
      var that = this
      // 这里通过高德 SDK 完成。
      // eslint-disable-next-line no-undef
      var geocoder = new AMap.Geocoder({
        radius: 1000,
        extensions: 'all'
      })
      console.log('positionArr>>>>>', positionArr)

      geocoder.getAddress(positionArr, (status, result) => {
        console.log('getAddress>>>>status>>>>>', status)
        console.log('getAddress>>>>result>>>>', result)

        if (status === 'complete' && result.info === 'OK') {
          if (result && result.regeocode) {
            const detailObj = {
              addressComponent: result.regeocode.addressComponent,
              detailedAddress: result.regeocode.formattedAddress,
              lng: positionArr[0],
              lat: positionArr[1]
            }

            // that.amapInfo = detailObj
            console.log('markers>>>>>>>>>>>>>>>', that.markers)

            const markersArr = []
            markersArr.push({
              lng: positionArr[0],
              lat: positionArr[1],
              name: result.regeocode.formattedAddress,
              address: result.regeocode.formattedAddress
            })

            that.markers = markersArr

            console.log('地址信息>>>>', detailObj)
            console.log('地址标记点信息>>>>', that.markers)
            that.$emit('mapInfo', detailObj)
          }
        } else {
          if (that.errorInfo[result]) {
            that.$message.error(that.errorInfo[result])
          }
        }
      })
    }
  }
}
</script>

<style lang="less">
.marker-info {
  position: relative;
  width: 200px;
  display: flex;
}

.marker-info-img {
  width: 35px !important;
  height: 41px !important;
}

.marker-info-text {
  width: 100%;
  position: absolute;
  top: -20px;
  left: -45%;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.nesyds {
  /* position: absolute !important; */
  background: rgba(13, 46, 100, 0.8) !important;
  width: 330px !important;
  height: 150px !important;
  border-radius: 7px;
  color: #fff !important;
  padding-top: 18px;
  padding-right: 16px;
  overflow-y: auto;

  /* padding-top: 20px !important; */
  /* top: 0 !important;
  left: 0 !important; */
  .images {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  #devDel {
    color: #00F6FF;
  }

  .tab {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.49);
    font-size: 16px;
    padding-left: 21px;

    div {
      margin-right: 27px;
      cursor: pointer;
    }
  }

  .textCent {
    padding-left: 21px;
    // margin-bottom: 15px;
    font-size: 12px;
    padding-top: 8px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    // overflow: hidden !important;
    width: 100%;
    // width: 200px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // text-align: left;
    // background: red !important;
  }
}

.search-box {
  width: 30%;
  position: absolute;
  top: 15px;
  left: 3%;
  z-index: 999;

  .el-amap-search-box {
    position: absolute;
    top: 40px;
    left: 0;
    width: 100%;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    z-index: 9999;
    padding: 10px;
    max-height: 200px;
    overflow-y: auto;
  }
  .el-amap-search-item {
    padding: 5px 10px;
    cursor: pointer;
    &:hover {
      background-color: #f0f0f0;
    }
  }
}
</style>
